module.exports = __webpack_public_path__ + "13275d35879e96be6c009687e3c38344.woff";